var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddIcon = function SvgAddIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2054 0.832031C6.03794 0.832031 1.84888 4.93609 1.84888 9.9987C1.84888 15.0613 6.03794 19.1654 11.2054 19.1654C16.3729 19.1654 20.5619 15.0613 20.5619 9.9987C20.5619 4.93609 16.3729 0.832031 11.2054 0.832031ZM11.2054 1.66536C15.9031 1.66536 19.7113 5.39632 19.7113 9.9987C19.7113 14.6011 15.9031 18.332 11.2054 18.332C6.50771 18.332 2.69947 14.6011 2.69947 9.9987C2.69947 5.39632 6.50771 1.66536 11.2054 1.66536Z",
    fill: "#ADB5BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.056 6.68262C12.056 6.21285 11.6751 5.83203 11.2054 5.83203C10.7356 5.83203 10.3548 6.21285 10.3548 6.68262V9.16537H7.78573C7.32549 9.16537 6.95239 9.53846 6.95239 9.9987C6.95239 10.4589 7.32549 10.832 7.78573 10.832H10.3548V13.3148C10.3548 13.7845 10.7356 14.1654 11.2054 14.1654C11.6751 14.1654 12.056 13.7845 12.056 13.3148L12.056 10.832L14.625 10.832C15.0852 10.832 15.4583 10.4589 15.4583 9.9987C15.4583 9.53846 15.0852 9.16537 14.625 9.16537H12.056V6.68262Z",
    fill: "#ADB5BD"
  })));
};
export default SvgAddIcon;